import {Component, Prop, Vue} from 'vue-property-decorator'
import {ICustomerExtendData, IModalControlButton, IModalStep} from '@/entities'

@Component
class modalStepMixin extends Vue {
  @Prop() data!: IModalStep
  @Prop() readonly subject!: any
  @Prop() readonly person?: ICustomerExtendData
  @Prop() readonly updateHandler?: Function

  protected getHandlers(): { [key: string]: Function } {
    return {};
  }

  private handlers = this.getHandlers();

  mounted() {
    let update = this.updateHandler;
    if (update) {
      this.data.controls.forEach((control: IModalControlButton) => {
        control.handler = update ? update(control.handler, this.handlers[control.id]) : control.handler;
      });
    }
  }

}

export default modalStepMixin
